// latest: zhangmyh 2017-8-24 7:10 PM
import 'ko-epui/dist/ko-epui.css'
import 'ko-epui'
import 'components'
import './index.less'
import '../common/home/header.less'
import initlayout from '../common/home/header.js'
import { Get } from 'common'
// 假数据
import testdata from '../../../mock/home.js'
// 轮播图
import 'static/jqueryplugins/unslider.min.js'
import 'static/jqueryplugins/slide.js'
import 'static/jqueryplugins/scroll.js'
import 'components/filesupload'
import uMessage from 'components/message'
/* global ko $ */

let piclist = []
let pic
pic = require('static/img/ky/bg.png')
piclist.push(pic)
var id = window.global.query('id')
let basicInform = {}
initViewModel()
//let questionClassData = await getHomeImg(9, 'fhmm0ixs')
//getHomeImg(9, 'fhmm0ixs')
$.ajax({
  url: '/cpu-supplymgr/homepageEnterpriseInfo/getHomepageEnterpriseInfoById',
  data: { id: id },
  type: 'get',
  dataType: 'json',
  contentType: 'application/json',
  success: function (data) {
    // debugger
    if (data.status == 1) {
      console.log('data', data.data)
      var inform = JSON.parse(data.data)
      file(inform.supplyDocId)
      // 表头基础数据
      viewModel.companyProfile1(inform.companyProfile1)
      viewModel.companyProfile2(inform.companyProfile2)

      // 设置加载隐藏
      //viewModel.initNotOver(false)
    } else {
      uMessage('fail', '查询失败')
    }
  },
  error: function (err) {
    console.log(err)
  }

})

testdata.purchaser[0].url = require('static/img/home/suppliers/1.png')
testdata.purchaser[1].url = require('static/img/home/suppliers/2.png')
testdata.purchaser[2].url = require('static/img/home/suppliers/3.png')
testdata.purchaser[3].url = require('static/img/home/suppliers/4.png')
testdata.purchaser[4].url = require('static/img/home/suppliers/5.png')
testdata.purchaser[5].url = require('static/img/home/suppliers/6.png')

testdata.salesClassifyList[0].url = require('static/img/home/suppliers/sales1.png')
testdata.salesClassifyList[1].url = require('static/img/home/suppliers/sales2.png')
testdata.salesClassifyList[2].url = require('static/img/home/suppliers/sales3.png')

var viewModel
var handTop = 0
let selectSearchCombo = '01'
var editpage = window.global.query('editpage')
editpage = true;

function initViewModel() {
  viewModel = {

    companyProfile1: ko.observable(),
    companyProfile2: ko.observable(),
    enterpriseId: ko.observable(window.global.user.enterpriseId),
    pagePath: ['ag_miningIndustry'],
    pic1: ko.observable(),
    pic2: ko.observable(),
    pic3: ko.observable(),
    pic4: ko.observable(),
    pic5: ko.observable(),
    pic6: ko.observable(),
    pic7: ko.observable(),
    pic8: ko.observable(),
    pic9: ko.observable(),
    pic10: ko.observable(),
    //bgp: require('static/img/ky/bg.png'),
    // pic1: require('static/img/ky/01.png'),
    // pic2: require('static/img/ky/building.png'),
    // pic3: require('static/img/ky/02.png'),
    // pic4: require('static/img/ky/table1.png'),
    // pic5: require('static/img/ky/table2.png'),
    editpage: ko.observable(editpage),
    id: ko.observable(''),
    //bannerbgp: ko.observable(),
    bannerbgp: require('static/img/ky/bannerbg.png'),
    item1Id: ko.observable(''),
    item1Name: ko.observable(''),
    currentMenuId: ko.observable(''),
    searchComboData: ko.observableArray([]),
    selectedSupplyCategory: ko.observable('01'),
    filterContent: ko.observable(''),
    newId: ko.observable(1),
    newUrl: ko.observable('../home_supplyBlack/index.zh_CN.html?id=1'),
    newTitle: ko.observable(),
    newSummary: ko.observable(),
    selectedSupplyCategoryName: ko.observable('采购分类'),
    categoryList: ko.observableArray([]),
    materialClassList: ko.observableArray(testdata.materalclass),
    announcementList: ko.observableArray([]),
    salesClassifyList: ko.observableArray(testdata.salesClassifyList),
    selectedSalesClassify: ko.observable('1'),
    selectedSalesClassifyName: ko.observable('系统集成类'),
    supplierBlackList: ko.observableArray([]),
    purchaserList: ko.observableArray(testdata.purchaser),
    childrenCategoryList: ko.observableArray([]),
    welcomeText: ko.observable('未登录'),
    loginText: ko.observable('登录'),
    registerText: ko.observable('注册'),
    hotlinepic: require('static/img/home/hotline4.png'),
    bidtitlepic: require('static/img/home/suppliers/bid_title0.jpg'),
    piclist,
    arrowlpic: require('static/img/home/arrowl.png'),
    arrowrpic: require('static/img/home/arrowr.png'),
    searchTypeText: ko.observable(''),
    getSelectHref: function (item2, item3) {
      return '../materialDetail/index.zh_CN.html?mdId=' + item3.id
      //  return '../classDescribeBySelect/index.zh_CN.html?items=' + viewModel.item1Name() + '#' + viewModel.item1Id() + '$' + item2.name + '#' + item2.id + '$' + item3.name + '#' + item3.id + '&id=' + item3.id
    },
    getItemHref: function (id) {
      return '../materialDetail/index.zh_CN.html?mdId=' + id
      //  return '../classDescribeBySelect/index.zh_CN.html?items=' + viewModel.item1Name() + '#' + viewModel.item1Id() + '$' + item2.name + '#' + item2.id + '$' + item3.name + '#' + item3.id + '&id=' + item3.id
    },
    getChildrenCategoryList: function (pid) {
      let result
      let categoryList = this.categoryList()
      if (categoryList && categoryList.length > 0) {
        for (let i in categoryList) {
          if (categoryList[i].id == pid) {
            result = categoryList[i].children
            break
          }
        }
      }
      return result
    },
    onCateMouseOver: function (data, event) {
      let et = $(event.target)
      let from = $(event.fromElement)
      if (et[0].tagName == 'LI') {
        handTop = et.position().top
        viewModel.item1Id(data.value)
        viewModel.item1Name(data.text)
        viewModel.childrenCategoryList(viewModel.getChildrenCategoryList(data.value))
        if (et[0].className == 'selectOne') {
          $('.selectOne').css('border-bottom', '1px dashed #CAD1DA')
          $('.selectOne').css('box-shadow', 'none')
          $('.selectOne').eq(data.value - 1).css('border', 'none')
          $('.selectOne').eq(data.value - 1).css('box-shadow', '1px 0px 1px #DDDDDD')
          if (data.value !== 1) {
            $('.selectOne').eq(data.value - 2).css('border', 'none')
            $('.selectOne').eq(data.value - 2).css('box-shadow', '1px 0px 1px #DDDDDD')
          }
          $(et).siblings().css('color', '#FFFFFF')
          $(et).siblings().css('font-weight', 'normal')
          $(et).siblings().css('border-left', '0px solid #E23838')
          $(et).siblings().children('a').css('color', '#9198A2')

          $(et).css('color', '#D7322A')
          $(et).css('font-weight', 'bolder')
          $(et).css('border-left', '4px solid #E23838')
          $(et).children('a:eq(0)').css('color', '#E23838')
        } else if (from[0].className == 'selectOne' && et[0].className == 'selectChildren') {
          $(from).css('color', '#D7322A')
          $(from).css('font-weight', 'bolder')
          $(from).css('border-left', '4px solid #E23838')
          $(from).children('a:eq(0)').css('color', '#E23838')
        }
      }
      $('#category_list_content_hand').css('top', handTop)
      $('#category_list_content').show()
      $('#category_list_content_hand').show()
    },
    onCateMouseLeave: function (data, event) {
      $('#category_list_content').hide()
      $('#category_list_content_hand').hide()
    },
    onCateBoxMouseLeave: function (data, event) {
      $('#materialUl').children('.selectOne').css('color', '#FFFFFF')
      $('#materialUl').children('.selectOne').css('font-weight', 'normal')
      $('#materialUl').children('.selectOne').css('border-left', '0px solid #E23838')
      $('#materialUl').children('.selectOne').children('a').css('color', '#9198A2')
      // 边框恢复
      $('.selectOne').css('border-bottom', '1px dashed #CAD1DA')
      $('.selectOne').css('box-shadow', 'none')
    },
    onSelectCategory: function (data, event) {
      selectSearchCombo = data.value
      viewModel.selectedSupplyCategory(data.value)
      viewModel.selectedSupplyCategoryName(data.name)
    },
    searchByType: function () {
      if (selectSearchCombo == '02') {
        window.location.href = '../home_salesClassify/index.zh_CN.html?content=' + viewModel.filterContent()
      } else {
        window.location.href = '../classDescribeBySearch/index.zh_CN.html?content=' + viewModel.filterContent()
      }
    }
  }
  initlayout(viewModel)

  window.app = window.u.createApp({
    el: 'body',
    model: viewModel
  })

  // 获取类目数据
  Get('/yuncai/materialClass/getAllClass3', {
    entid: window.global.user.PURCHASEID,
    classLevel: 3
  }).then(function (data, status) {
    if (status == 'success') {
      viewModel.categoryList(data)
    }
  })


  // //获取销售分类数据
  // Get('/cpu-supplymgr/saleClass/getAllClass3', {entid: window.global.user.PURCHASEID, classLevel: 3}).then(function (data, status) {
  //   if (status == 'success') {
  //     viewModel.salesClassifyList(data)
  //   }
  // })
  // 获取黑名单数据
  // Get('/cpu-supplymgr/supplyBlack/getAllSupplyBlacks').then(function (data, status) {
  //   if (status == 'success') {
  //     viewModel.supplierBlackList(data)
  //   }
  // })

  $('.scroll-list').myScroll({
    speed: 40, // 数值越大，速度越慢
    rowHeight: 35 // li的高度
  })

  // 获取公告数据
  // Get('/cpu-supplymgr/latestAnnouncement/getLatestAnnouncements').then(function (data, status) {
  //   if (status == 'success') {
  //     viewModel.announcementList(data)
  //     viewModel.newId = viewModel.announcementList()[0].id
  //     var url = 'http://bid.ansteel.cn/ForePage/Skin/ViewDetail.aspx?cmptypenum=2&id=' + viewModel.announcementList()[0].id
  //     viewModel.newUrl(url)
  //     viewModel.newTitle(cutString(viewModel.announcementList()[0].title, 44))
  //     let sum = viewModel.announcementList()[0].summary
  //     viewModel.newSummary(cutString(sum, 180))
  //     var objArray = []
  //     for (let x in viewModel.announcementList()) {
  //       let t = viewModel.announcementList()[x].title
  //       let ct = cutString(t, 40)
  //       var s = {}
  //       s.id = viewModel.announcementList()[x].id
  //       s.title = ct
  //       s.date = viewModel.announcementList()[x].date.substring(0, 10)
  //       viewModel.announcementList()[x].title = ct
  //       if (x > 0) {
  //         objArray.push(s)
  //       }
  //       //  viewModel.announcementList.shift()
  //     }
  //     viewModel.announcementList([])
  //     viewModel.announcementList(objArray)
  //     //  viewModel.announcementList.shift()
  //   }
  // })
}

// function cutString (str, len) {
//   // length属性读出来的汉字长度为1
//   if (str.length * 2 <= len) {
//     return str
//   }
//   var strlen = 0
//   var s = ''
//   for (var i = 0; i < str.length; i++) {
//     s = s + str.charAt(i)
//     if (str.charCodeAt(i) > 128) {
//       strlen = strlen + 2
//       if (strlen >= len) {
//         return s.substring(0, s.length - 1) + '...'
//       }
//     } else {
//       strlen = strlen + 1
//       if (strlen >= len) {
//         return s.substring(0, s.length - 2) + '...'
//       }
//     }
//   }
//   return s
// }
// const getHomeImg = async function (id, tenantid) {
//   //function getHomeImg(id, tenantid) {
//   var filepath = 'homepageEnterpriseInfo' + id
//   let result = await Get('/file/file/query', {
//     filepath: filepath,
//     groupname: 'homepageEnterpriseInfo',
//     tenant: tenantid
//   })
//   if (result.status == 1 && result.data.length > 0) {
//     return result.data.map(function (item) {
//       return {
//         name: item.filename,
//         url: item.url.indexOf('http') >= 0
//           ? item.url : ('http://' + item.url)
//       }
//     })
//   }
//   return []
// }
function file(code) {
  //self.viewmodel.fileList([])
  //var user = Common.store.get("user");
  //标底附件地址
  $.ajax({
    url: '/cpu-supplymgr/homepageEnterpriseInfo/getImgFilesById',
    type: "get",
    async: false,
    data: {
      id: code
    },
    dataType: 'json',
    contentType: 'application/json',
    success: function (data) {
      if (data.data) {
        var allpicture = JSON.parse(data.data)
        for (let i = 0; i < allpicture.length; i++) {
          var groupname = allpicture[i].groupname
          // if ()
          var url = allpicture[i].url
          switch (groupname) {
            // case 'homepageEnterpriseInfo_1_':
            //   viewModel.pic1(url)
            //   break
            case 'homepageEnterpriseInfo_2_':
              viewModel.pic2(url)
              break
            case 'homepageEnterpriseInfo_3_':
              viewModel.pic3(url)
              break
            case 'homepageEnterpriseInfo_4_':
              viewModel.pic4(url)
              break
            case 'homepageEnterpriseInfo_5_':
              viewModel.pic5(url)
              break
            case 'homepageEnterpriseInfo_6_':
              viewModel.pic6(url)
              break
            case 'homepageEnterpriseInfo_7_':
              viewModel.pic7(url)
              break
            case 'homepageEnterpriseInfo_8_':
              viewModel.pic8(url)
              break
            case 'homepageEnterpriseInfo_9_':
              viewModel.pic9(url)
              break
            case 'homepageEnterpriseInfo_10_':
              viewModel.pic10(url)
              break

          }
          // if (allpicture[i].groupname == homepageEnterpriseInfo_1) {

          // } else { }
        }

        // viewModel.bgp('http://test.ansteelscm.com/group1/M00/00/76/CkQKEGGzImSAJ02CAABLzwhHTXc698.png')

        //     return {
        //       name: item.filename,
        //       url: item.url.indexOf('http') >= 0
        //         ? item.url : ('http://' + item.url)
        //     }
        //   })
        // for (let i = 0; i < data.data.length; i++) {
        //   self.viewmodel.fileList().push({ "secId": 9, "fileType": "标底附件", "url": data.data[i].url })
        // }
      }
    }
  })
}


(function () {
  // init()
  // 判断登录
  viewModel.loadUser()
})()



// WEBPACK FOOTER //
// ./src/pages/ag_miningIndustry/index.js